import { Utils } from '@genial/utils';

import { InputMoneyProps } from '../../../components/InputMoney';
import { AddedProductItemFixedIncomeProps } from '../components/Cart/components/AddedProductItem/FixedIncome';
import { useFixedIncomeAssetController } from '../components/DynamicAsset/hooks/products/FixedIncome';

import { useBatchTicketCartActionItem } from './batchTicketCartActionItem';

interface useFixedIncomeAddedProductItemProps extends AddedProductItemFixedIncomeProps {}

export const useFixedIncomeAddedProductItem = ({
  data: item,
  type,
}: useFixedIncomeAddedProductItemProps) => {
  const inputIsDisabled = type === 'requiredAttention';
  const { isLoadingAction, onRemoveProduct, onUpdateProduct } =
    useBatchTicketCartActionItem<'fixedIncome'>({
      item,
      id: 'fixedIncome',
      idSelector: 'productId',
      type,
    });

  const {
    control,
    currentValueFormatted,
    handleInputBlur,
    handleInputClear,
    handleInputFocus,
    handleSubmit,
    hasError,
    helpText,
    helpTextProps,
    isFocused,
    showMessageAdjustUnitPrice,
    selectedFee,
    selectedFeeId,
    setSelectedFeeId,
    minApplication,
    estimatedIncomeCalculated,
    estimatedNetValueCalculated,
  } = useFixedIncomeAssetController(item, onUpdateProduct);

  const isRequiredAttention = type === 'requiredAttention';
  const isTotalSummary = type === 'totalSummary';
  const useAmountValue = (isRequiredAttention || isTotalSummary) && item.amount;
  const currentValue = useAmountValue ? Utils.Mask.Money(item.amount) : currentValueFormatted;

  const inputMoneyDataProps = {
    id: `product-added-applied-amount-${item.productIdNormalized}`,
    name: 'createAppliedAmount',
    control,
    isDisabled: inputIsDisabled,
    currentValue,
    hasFocus: isFocused,
    minValue: minApplication,
    customInputProps: {
      ...{
        ...(showMessageAdjustUnitPrice && {
          helpTextProps,
          helpText,
        }),
      },
      ...(isFocused && hasError && { error: hasError }),
      ...(isFocused && !hasError && { helpText }),
    },
    handleFocus: handleInputFocus,
    handleBlur: handleInputBlur,
    handleSubmit,
    handleClear: handleInputClear,
  } as InputMoneyProps;

  return {
    inputMoneyDataProps,
    messageAdjustUnitPriceIsVisible: showMessageAdjustUnitPrice,
    inputIsFocused: isFocused,
    onRemoveProduct,
    isLoadingAction,
    ableToChangeFees: false,
    selectedFee,
    selectedFeeId,
    setSelectedFeeId,
    minApplication,
    estimatedIncomeCalculated,
    estimatedNetValueCalculated,
  };
};
